/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as FeedDefs from './defs.defs.js'

const $nsid = 'app.bsky.feed.getFeedGenerators'

export { $nsid }

/** Get information about a list of feed generators. */
const main = l.query(
  $nsid,
  l.params({ feeds: l.array(l.string({ format: 'at-uri' })) }),
  l.jsonPayload({
    feeds: l.array(
      l.ref<FeedDefs.GeneratorView>((() => FeedDefs.generatorView) as any),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
